import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalsService } from 'src/app/services/core/globals';

@Component({
  selector: 'withdraw-wallet',
  templateUrl: './withdraw-wallet.component.html',
  styleUrls: ['./withdraw-wallet.component.scss'],
})
export class WithdrawWalletComponent {
  @Input() modalId: string = '';

  @Input() walletId: string = '';

  @Input() currency: { country: string; code: string; iso2: string } | null =
    null;

  @Output() emitTopupWallet: EventEmitter<any> = new EventEmitter<any>();

  modalForm: FormGroup = new FormGroup({
    amount: new FormControl(
      0,
      Validators.compose([Validators.required, Validators.min(1)])
    ),
    purpose: new FormControl('', Validators.compose([Validators.required])),
    type: new FormControl(''),
    wallet: new FormControl('', Validators.compose([Validators.required])),
    currency: new FormControl(null, Validators.compose([Validators.required])),
  });

  transactionPurposeList: string[] = ['Escrow funding'];

  constructor(public globals: GlobalsService) {}

  ngOnChanges() {
    if (
      !this.modalForm.value.wallet ||
      !this.modalForm.value.currency
    ) {
      this.modalForm.patchValue({
        wallet: this.walletId,
        currency: this.currency,
        type: 'debit',
      });
    }
  }

  async onSubmit() {
    if (this.modalForm.valid) {
      this.modalForm.patchValue({
        amount: this.formatToNumber(this.modalForm.value.amount),
      });
      this.emitTopupWallet.emit(this.modalForm.value);
      this.modalForm.reset({
        amount: 0,
        purpose: '',
        type: 'credit',
        wallet: this.walletId,
        currency: this.currency,
      });
      
    }
  }

  formatAmount(event: any, type: string) {
    // format the amount to have commas and decimals
    let amount = event.target.value;
    amount = amount.replace(/,/g, '');
    amount = amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

    // allow only numbers, commas and decimals
    amount = amount.replace(/[^0-9,\.]/g, '');
    event.target.value = amount;
    this.modalForm.patchValue({
      [type]: amount,
    });
    // trigger validation
    this.modalForm.controls[type].markAsTouched();
    this.modalForm.controls[type].markAsDirty();
    this.modalForm.updateValueAndValidity();
  }

  formatToNumber(amount: string | number): number {
    if (typeof amount === 'number') return amount;
    return Number(amount?.replace(/,/g, '') || 0);
  }

  startDropDown(id: string) {
    let dropDown = document.querySelector(`#${id}`) as HTMLElement;
    dropDown.classList.toggle('active');
    // Close the dropdown if the user clicks outside of it
    document.addEventListener('click', function (e: any) {
      if (!dropDown.contains(e.target)) {
        dropDown.classList.remove('active');
      }
    });
  }

  selectPurpose(purpose: string) {
    this.modalForm.patchValue({
      purpose: purpose,
    });
  }

  get amount() {
    return this.modalForm.get('amount') as FormControl;
  }

  get purpose() {
    return this.modalForm.get('purpose') as FormControl;
  }

  get tranx_ref() {
    return this.modalForm.get('tranx_ref') as FormControl;
  }
}
